export default "<div class=\"overview-container\">\r\n  <app-login></app-login>\r\n</div>\r\n";